module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n    Phrase Details\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/phrases_list"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Add / Update Phrase")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrUpdate.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Phrase")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.phrase),
      expression: "gRowObj.phrase"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && !_vm.$v.gRowObj.phrase.required) || _vm.phraseExistError
    },
    attrs: {
      "type": "text",
      "id": "phrase",
      "placeholder": "Phrase"
    },
    domProps: {
      "value": (_vm.gRowObj.phrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "phrase", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.phrase.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter phrase.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.phraseExistError) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Phrase already exists.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country",
      "name": "country"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeCountry($event)
      }
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.country), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": data.id === _vm.gRowObj.country_id,
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.full_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose country.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "padding-15px"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('treeselect', {
    key: _vm.keywords.length,
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.keyword_id.required
    },
    attrs: {
      "async": true,
      "default-options": true,
      "placeholder": "--Choose a keyword--",
      "multiple": false,
      "load-options": _vm.loadOptions,
      "clearable": true
    },
    model: {
      value: (_vm.gRowObj.keyword_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "keyword_id", $$v)
      },
      expression: "gRowObj.keyword_id"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.keyword_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a keyword.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Phrase Configuration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-975dccae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/phrase-management/PhraseDetails.vue
// module id = np1b
// module chunks = 1